import { Injectable } from '@angular/core'
import { CollectionRepository, FirestoreQueryBuilder, OrderByDirection } from '@engineering11/web-api-firebase'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { COLLECTIONS } from 'shared-lib'
import { IAssistantMessage } from '../models/assistant.model'

/**
 * Live-listener store for the top-level `assistant_messages` collection the backend writes run replies
 * to (CAP-2). Filtered by the caller's Firebase auth uid + customerKey so the owner firestore rule
 * allows the read; ordered by `__createdAt` ascending. Mirrors `job-post.repository.ts`.
 */
@Injectable({ providedIn: 'root' })
export class AssistantMessageRepository extends CollectionRepository<IAssistantMessage> {
  // BACKEND CONTRACT (assumption) — see ../BACKEND-CONTRACT.md
  protected COLLECTION = COLLECTIONS.ASSISTANT_MESSAGES

  /** Live, ordered messages for a conversation owned by (authUid, customerKey). Emits every Firestore update. */
  liveMessages(authUid: string, customerKey: string, conversationId: string): Observable<IAssistantMessage[]> {
    const query = new FirestoreQueryBuilder<IAssistantMessage>()
      .where('authUid', '==', authUid)
      .where('customerKey', '==', customerKey)
      .where('conversationId', '==', conversationId)
      .orderBy('__createdAt', OrderByDirection.Asc)
      .build()
    // The backend stores the bubble body in `content`; the panel renders `text`. Map it here so the
    // model, template, and tests stay on `text` (single translation point for the backend contract).
    return this.queryValueChanges(query).pipe(
      map(messages => messages.map(m => ({ ...m, text: m.text ?? (m as { content?: string }).content ?? '' })))
    )
  }
}
